import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useSandpackNavigation } from "../../hooks/useSandpackNavigation";
import { RefreshIcon } from "../../icons";
export var RefreshButton = function RefreshButton(_ref) {
  var clientId = _ref.clientId;

  var _useSandpackNavigatio = useSandpackNavigation(clientId),
      refresh = _useSandpackNavigatio.refresh;

  var c = useClasser("sp");
  return React.createElement("button", {
    className: c("button", "icon-standalone"),
    onClick: refresh,
    title: "Refresh Sandpack",
    type: "button"
  }, React.createElement(RefreshIcon, null));
};